import React from 'react';

/**
 * Building blocks of Linear's right-hand properties panel, shared by the
 * violation and work-order detail pages.
 */

/** A titled group of properties. */
export const Section: React.FC<{ title: string; children: React.ReactNode }> = ({
  title,
  children,
}) => (
  <section className="py-3 first:pt-0">
    <h2 className="mb-1.5 px-2 text-[12px] font-medium text-fg-muted">
      {title}
    </h2>
    <div className="flex flex-col items-start gap-0.5">{children}</div>
  </section>
);

/** A read-only row: muted label, value. */
export const Fact: React.FC<{ label: string; children: React.ReactNode }> = ({
  label,
  children,
}) => (
  <div className="flex w-full items-baseline justify-between gap-3 px-2 py-1 text-[13px]">
    <span className="text-fg-muted">{label}</span>
    <span className="truncate text-right text-fg-secondary">{children}</span>
  </div>
);
